import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + '/v1/admin/';

const getCampaigns = (page = 0, size = 20, { category = 'all', type = 'all' } = {}) => {
    return axios.get(`${API_URL}campaigns`, {
        params: {
            page,
            size,
            category,
            type,
        },
    });
};

const getCampaignById = (campaignId) => {
    return axios.get(`${API_URL}campaigns/${campaignId}`);
};

const updateCampaign = (campaignId, status) => {
    const statusMap = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'ERROR'];
    const statusParam =
        typeof status === 'number' && status >= 0 && status < statusMap.length
            ? statusMap[status]
            : String(status).trim().toUpperCase();
    return axios.patch(`${API_URL}campaigns/${campaignId}`, null, {
        params: { status: statusParam },
    });
};

const deleteCampaign = (campaignId) => {
    return axios.delete(`${API_URL}campaigns/${campaignId}`);
};

const getCampaignResult = (campaignId, page = 0, size = 30) => {
    return axios.get(`${API_URL}campaigns/${campaignId}/results`, {
        params: { page, size },
    });
};

const getCampaignResultStats = (campaignId) => {
    return axios.get(`${API_URL}campaigns/${campaignId}/result-stats`);
};

const getEmailCampaignQueue = (campaignId, page = 0, size = 30) => {
    return axios.get(`${API_URL}campaigns/${campaignId}/email-queue`, {
        params: { page, size },
    });
};

const getSmsCampaignQueue = (campaignId, page = 0, size = 30) => {
    return axios.get(`${API_URL}campaigns/${campaignId}/sms-queue`, {
        params: { page, size },
    });
};

const getCampaignQueueByType = (campaignId, page = 0, size = 30, type = 'EMAIL') => {
    return type === 'SMS'
        ? getSmsCampaignQueue(campaignId, page, size)
        : getEmailCampaignQueue(campaignId, page, size);
};

// Backward-compatible aliases
const getCampaignEmailQueue = getEmailCampaignQueue;
const getCampaignSmsQueue = getSmsCampaignQueue;
const getCampaignQueue = getCampaignQueueByType;

const buildCampaignTemplateQuery = ({
    sortBy,
    sortOrder,
    searchTerm,
    typeFilter,
    activeFilter,
}) => {
    const parts = [];
    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }
    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }
    if (searchTerm?.trim()) {
        parts.push(`name==*${searchTerm.trim()}*`);
    }
    if (typeFilter) {
        parts.push(`type==${typeFilter}`);
    }
    if (activeFilter === 'true') {
        parts.push('isActive==true');
    }
    if (activeFilter === 'false') {
        parts.push('isActive==false');
    }
    return parts.join(',');
};

const getAllTemplates = (page = 0, size = 20, queryOptions = {}) => {
    const q = buildCampaignTemplateQuery(queryOptions);
    const params = { page, size };
    if (q) {
        params.q = q;
    }
    return axios.get(`${API_URL}campaign-templates`, { params });
};

const getTemplateById = (templateId) => {
    return axios.get(`${API_URL}campaign-templates/${templateId}`);
};

const addUpdateTemplate = (data) => {
    return axios.post(`${API_URL}campaign-templates`, data);
};

const updateTemplate = (templateId, data) => {
    return axios.put(`${API_URL}campaign-templates/${templateId}`, data);
};

const deleteTemplate = (templateId) => {
    return axios.delete(`${API_URL}campaign-templates/${templateId}`);
};

export default {
    getCampaigns,
    getCampaign: getCampaigns,
    getCampaignById,
    updateCampaign,
    deleteCampaign,
    getCampaignResult,
    getCampaignResultStats,
    getCampaignQueue,
    getCampaignQueueByType,
    getEmailCampaignQueue,
    getSmsCampaignQueue,
    getCampaignEmailQueue,
    getCampaignSmsQueue,
    getAllTemplates,
    getTemplateById,
    addUpdateTemplate,
    updateTemplate,
    deleteTemplate,
};
